const Prueba = () => {
  return (
    <>
      <h1 className="text-yellow-500 bg-slate-400 w-72">Hola mundo</h1>
    </>
  );
};

export default Prueba;
